module.exports = __webpack_public_path__ + "img/69.c2017d7f.jpg";